<template>
  <div class="contact-page">
    <h1>Rejoindre notre équipe</h1>
      <div v-if="error">{{ error }}</div>
      <div v-else-if="formSent" v-html="focus.paragraphe2 ? focus.paragraphe2.texte : 'Le formulaire a bien été envoyé.'"></div>
      <form v-else @submit.stop.prevent="addDemande" class="contact-page-form">
        <div>
          <div class="contact-page-form-field-container">
            <label for="name">Nom</label>
            <input id="name"
              name="name"
              placeholder="Votre nom"
              v-model="fiche.nom"
              required
            />
          </div>
          <div class="contact-page-form-field-container">
            <label for="surname">Prénom</label>
            <input id="surname"
              name="surname"
              placeholder="Votre prénom"
              v-model="fiche.prenom"
              required
            />
          </div>
          <div class="contact-page-form-field-container">
            <label for="email">Email</label>
            <input id="email"
              name="email"
              placeholder="Votre email"
              v-model="fiche.email"
              required
            />
          </div>
          <div class="contact-page-form-field-container">
            <label for="telephone">Téléphone</label>
            <input id="telephone"
              name="telephone"
              placeholder="Votre téléphone"
              v-model="fiche.telephone"
              required
            />
          </div>
          <div class="contact-page-form-field-container">
            <label for="cv">Votre CV</label>
            <input id="cv"
              type="file"
              @change="uploadCv"
              name="cv"
              required
            >
          </div>
        </div>
        <div>
          <div class="contact-page-form-field-container">
            <label for="questions" v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></label>
            <textarea id="questions"
              name="questions"
              placeholder="Vos questions"
              v-model="fiche.questions"
              rows="10" cols="40"
              maxlength="140"
            />
          </div>
          <div class="contact-page-form-submit-container">
            <strong>* Champs obligatoires</strong>
            <input type="submit"  id="envoyer"  value="Envoyer" class="cg-btn cg-btn-primary"/>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
import DataApi from '../../dependencies/index'
import { getFocus } from '../../mixins/getFocus'


export default {
  name: 'RecrutementForm',
  mixins: [getFocus],
  props: {
    siteCode: String
  },
  data () {
    return {
      fiche: {
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        adresse: '',
        d_salaire: 0,
        questions: '',
        type: 'recrutement',
        destinataire: this.siteCode
      },
      cv: null,
      formSent: false,
      error: null,
      errorMessage: 'Erreur de communication avec le serveur, veuillez nous excuser pour la gène occasionnée et recommencer plus tard',
      focus: {}
    }
  },
  methods: {
    async addDemande () {
      const demandeToSend = this.fiche
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.createRecord(
        'W_DemandeContact', 
        demandeToSend,
        [{
          name: 'validerFormulaire',
          type: 'postrequest'
        }]
      )
      .then((response) => {
        this.dataApi.uploadToContainer('W_DemandeContact', response, 'd_cv', '', this.cv)
        .then((res) => {
          this.formSent = true
        })
        .catch((err) => {
          this.error = this.errorMessage
        })
      })
      .catch((err) => {
        this.error = this.errorMessage
      })
        
    },
    uploadCv(event) {
      let cvInput = document.getElementById("cv")
      this.cv = cvInput.files ? cvInput.files[0] : ''
      console.log(this.cv)
    }
  },
  async beforeMount() {
    await this.getFocus(this.siteCode, 'Recrutement')
      .then(res => {
        this.focus = res
      })
  }
}
</script>
<style lang="scss" scoped>
.contact-page {
  max-width: var(--max-width);
  width: 100%;
  margin: 48px 0;
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.2);

  .contact-page-form {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;

    &>div {
      margin: 16px;
    }

    .contact-page-form-field-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 16px;

      input {
        height: 48px;
        width: 250px;
      }
      input, textarea {
        padding: .5rem 1rem;
        line-height: 1.5;
        border-radius: .3rem;
        border: 1px solid #ced4da;
        font-size: 0.8rem;
        font-weight: 600;

        &::placeholder {
          color: #C0C4CC;
        }
      }

      input:focus-visible, 
      textarea:focus-visible {
        outline: 2px solid var(--color-primary);
      }

      label {
        margin: 0;
      }
    }

    .contact-page-form-rgpd-container {
      display: flex;
      margin: 16px;

      p {
        max-width: 500px;
        margin: 16px;
      }
    }

    .contact-page-form-submit-container {
      margin: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .cg-btn {
        height: 50px;
        width: 250px;
        display: block;
        margin: 16px;
    }
  }
}
</style>
